export default "__VITE_ASSET__C4d5yVzR__"